var Map = (function () {
  
  var config = {
    count: 100 //Количество объектов карты, которые могут быть получены в результате запроса к серверу
  };

  var leafletMap;
  var popup;

  // Слои карты
  var mapOverlays = [];
  mapOverlays.get = function (name) {
    return this.filter(function (x) { return x.name === name; })[0];
  };
  mapOverlays.getGroup = function (group) {
    return this.filter(function (x) { return x.group === group; });
  };
  // Слой найденных объектов
  var searchOverlay;

  var cardContainerHeight = $(window).height() * 0.2;
  $('#modal-spinner').attr('style', 'height:' + cardContainerHeight + 'px;');

    function getDependedLayers(layers, currentLayer) {
        var dependedLayers = [];
        if (currentLayer.options && currentLayer.options.id) {
            var id = currentLayer.options.id;
            $.each(layers, function (idx, obj) {
                if (obj !== currentLayer && obj.options && obj.options.parentId && obj.options.parentId === id) {
                    dependedLayers.push(obj);
                }
            });
        }
        if (currentLayer.eachLayer)
            currentLayer.eachLayer(function(obj) {
                    dependedLayers.push(obj);
                });
        return dependedLayers;
    }

    function highlightLayer(ogj) {
        if (ogj._icon) {
            $(ogj._icon).toggleClass('popupopen');
        }
        else if (ogj._path) {
            // Для линий и полигонов класс добавляется только аттрибутом
            $(ogj._path).attr('class', 'leaflet-interactive popupopen');
        }
    }

    function hoverLayer(obj, hover) {
        if (obj._icon) {
            if (hover)
                $(obj._icon).addClass('leaflet-marker-icon--hover');
            else
                $(obj._icon).removeClass('leaflet-marker-icon--hover');
        }
        else if (obj._path) {
            if (hover) {
                var hoverClass = $(obj._path).attr('class');
                if (hoverClass.indexOf('leaflet-clickable--hover') === -1) {
                    hoverClass += ' leaflet-clickable--hover';
                    $(obj._path).attr('class', hoverClass);
                }
            } else {
                var classValue = $(obj._path).attr('class');
                classValue = classValue.replace('leaflet-clickable--hover', '');
                $(obj._path).attr('class', classValue.trim());
            }
        }
    }

    function loadWStationTooltip(url, marker) {
        marker.options.loadingTooltip = true;
        $.ajax({
                url: url,
                contentType: 'application/html; charset=utf-8',
                type: 'GET',
                dataType: 'html'
            })
            .success(function (result) {
                if (marker.getTooltip()) {
                    marker.setTooltipContent(result);
                } else
                    marker.bindTooltip(result, { opacity: 1, offset: L.point(0, -30) });
                marker.options.loadedTooltip = true;
                marker.options.loadingTooltip = false;
            })
            .error(function (xhr, status) {
                marker.options.loadingTooltip = false;
                console.error(status);
            });
    }

    function mapInit() {

    popup = L.popup();

        //L.Icon.Default.imagePath = Url.content('Content/Leaflet/images');
        L.Icon.Default.imagePath = AppConfig.imagePath;

    var grayscale = L.tileLayer(MapSettings.urlFormat, {
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      noWrap: true
    });
    var streets = L.tileLayer('http://{s}.tile.thunderforest.com/transport/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      noWrap: true
    });

    leafletMap = L.map('mapDiv', {
      zoomControl: false,
      zoom: AppConfig.defaultMapZoom,
      layers: [grayscale],
      maxBounds: L.latLngBounds(AppConfig.defaultMapBounds[0], AppConfig.defaultMapBounds[1]),
      minZoom: AppConfig.defaultMapMinZoom,
      zoomReverse: true,
      center: AppConfig.defaultMapCenter,
      editable: true
    });
    L.control.zoom({
        zoomInTitle: 'Приблизить',
        zoomOutTitle: 'Отдалить',
        position: 'topleft'
        }).addTo(leafletMap);

    Ruler.init(leafletMap);

    $('#mapDiv').on('xresize', function () {
      leafletMap.invalidateSize(true);
    });

    var $card;
    // Map Events
        leafletMap
      .on('popupopen', function(e) {
        e.popup.options.autoPan = false; // Отключает следование за картой при открытой карточке
        if (e.popup.options.id != undefined && e.popup.options.typeId != undefined) {
          leafletMap.closePopup();
          $('#sidebar-js').removeClass('menu-show');
          $card = showCard(CardUrls[ObjectTypes.getName(e.popup.options.typeId)].format(e.popup.options.id)); // Показываем наш
        }
        $.each(e.target._layers, function (idx, ogj) {
          // Если попап слоя идентичен открытому попапу, то активируем маркер или линию
          if (ogj._popup == e.popup) {
              highlightLayer(ogj);

            var dependedLayers = getDependedLayers(e.target._layers, ogj);
              if (dependedLayers.length > 0) {
                  $.each(dependedLayers, function(ind, layer) {
                      highlightLayer(layer);
                  });
              }
          }
        });
      })
      .on('popupclose', function(e) {
        $.each(e.target._layers, function(idx, ogj) {
          if (ogj._popup == e.popup && $card && e.popup.options.id && e.popup.options.typeId) {
            hideCard(leafletMap, $card);
          }
        });
      })
      .on('click', function(e) {
          if (!Ruler.isActive())
            popup
              .setLatLng(e.latlng)
              .setContent('Широта: ' + e.latlng.lat + '<br>' + 'Долгота: ' + e.latlng.lng)
              .openOn(leafletMap);
      });

    // Add control panel on map
    L.control.layers({ 'Grayscale': grayscale, 'Streets': streets }).addTo(leafletMap);
    $('.leaflet-control-layers-toggle').attr('title', 'Слои');

    // Скрытие стандартного меню Leaflet (необходимо для работы меню слоев на мобильных устройствах)
    L.DomEvent
      .on($('.leaflet-control-layers.leaflet-control')[0], 'mouseover', function () {
        L.DomUtil.removeClass($('.leaflet-control-layers.leaflet-control')[0], 'leaflet-control-layers-expanded');
      }, this)
      .on($('.leaflet-control-layers-toggle')[0], 'click', function () {
        L.DomUtil.removeClass($('.leaflet-control-layers.leaflet-control')[0], 'leaflet-control-layers-expanded');
        $('#sidebar-js').toggleClass('menu-show');
      }, this)
      .on($('.leaflet-control-layers-toggle')[0], 'focus', function () {
        L.DomUtil.removeClass($('.leaflet-control-layers.leaflet-control')[0], 'leaflet-control-layers-expanded');
      }, this);

    return leafletMap;
  }

  function pageInit(weatherOptions) {

    //функция для добавления слоя для объектов на карту,
    //использовать эту функцию не обязательно
    var addOverlay = function (name) {
      var newOverlay = new Overlay(name, leafletMap, L.featureGroup());
      //общее поведение для всех слоев, в случае скрытия слоя
      newOverlay
        .on('hide', function(overlay) {
          //очищаем слой, чтобы не хранить в памяти лишние объекты
          overlay.clearLayers();
          overlay.canUpdate = false;
          // Условие деактивации пункта меню
          if (!overlay.alreadyActive) {
            $('[data-id=' + overlay.name + ']').closest('.active').removeClass('active');
          }
        });
      mapOverlays.push(newOverlay);

      return newOverlay;
    };
    
    //добавим слой найденных объектов на карту
    searchOverlay = addOverlay('Search');

    // Инициализируем плагин для поиска объектов на карте и их отрисовки
    initSearch();

    var vehiclesLayer = []; // Слои ТС

    // Применение фильтра "За последний час" для ТС
    $('#IsCommunicationTimed').on('change', function (e) {
        _onChange($(this));
    });

    // Применение фильтра "Скорость от ..." для ТС
    $('#HasMinSpeed').on('change', function (e) {
        _onChange($(this));
    });

      // Применение фильтра
    function _onChange($checkbox) {
        var promises = []; // Промисы с функционалом скрытия для слоев
        var layersCount = 0; // Кол-во отрисованных слоев
        _disableCheck();
        vehiclesLayer.forEach(function (overlay) {
            if (overlay.isShown) {
                _disableCheck();
                layersCount++;
                promises.push(_vehicleTimeChanged(overlay));
            }
        });
        if (layersCount === 0)
            _enableCheck(0, 0);
        var updatedLayers = 0; // Счетчик обработанных слоев
        promises.forEach(function (promise) {
            promise.then(hiddenOverlay => {
                // Выполняется, если пришлось ожидать завершения отрисовки слоя
                hiddenOverlay.show(); // Показать слой
                updatedLayers++;
                _enableCheck(updatedLayers, layersCount); // Активация checkBox
            }, hiddenOverlay=> {
                // Выполняется сразу после инициализации фильтра
                hiddenOverlay.show(); // Показать слой
                updatedLayers++;
                _enableCheck(updatedLayers, layersCount); // Активация checkBox
            });
        });
    }

    // Активация checkBox
    // updatedLayers - кол-во обработанных слоев
    // layersCount - общее кол-во слоев
    function _enableCheck(updatedLayers, layersCount) {
        if (updatedLayers === layersCount) {
            $('#HasMinSpeed').removeAttr('disabled');
            $('#IsCommunicationTimed').removeAttr('disabled');
      }
    }

      // Блокировка checkBox
      function _disableCheck() {
          $('#HasMinSpeed').attr('disabled', 'disabled');
          $('#IsCommunicationTimed').attr('disabled', 'disabled');
      }

    // Функция стирания слоя с карты
    // overlay - слой
    function _vehicleTimeChanged(overlay) {
      var promise = new Promise(function (resolve, reject) {
        // Проверка на наличие ожидания завершения отрисовки слоя
        if (!overlay.canUpdate) {
          var intervalID = setInterval(() => {
            // Проверяем на завершение отрисовки слоя
            if (overlay.canUpdate) {
              clearInterval(intervalID); // Прерываем циклическое выполнение интервала
              overlay.alreadyActive = true; // Пункт меню всегда активен
              overlay.hide(); // Скрываем отображенные слои
              resolve(overlay);
            }
          }, 1000);
        } else {
          overlay.alreadyActive = true; // Пункт меню всегда активен
          overlay.hide(); // Скрываем отображенные слои
          reject(overlay);
        }
      });

      return promise;
    }

    // Инициализация групп объектов
    // Зоны обслуживания
    addOverlay(ObjectTypes.getName(ObjectTypes.ServiceZone))
      .on('show', function (overlay) {
        loadServiceZones(overlay);
      });

    // Автодороги
    RoadTypes.forEach(function (type) {
      addOverlay(ObjectTypes.getName(ObjectTypes.Road) + '-' + type.Id)
        .on('show', function (overlay) {
          loadRoads(type.Id, overlay);
        });
    });

    // Населенные пункты
    addOverlay(ObjectTypes.getName(ObjectTypes.Locality))
      .on('show', function (overlay) {
        loadLocalities(overlay);
      });

    // Участки обслуживания
    SSegmentTypes.forEach(function (type) {
      addOverlay(ObjectTypes.getName(ObjectTypes.SSegment) + '-' + type.Value)
        .on('show', function (overlay) {
          loadSSegments(type.Value, overlay);
        });
    });

    // Протяженные объекты
    LongObjectTypes.forEach(function (type) {
      addOverlay(ObjectTypes.getName(ObjectTypes.LongObject) + '-' + type.Id)
        .on('show', function (overlay) {
          loadLongObjects(type.Id, overlay);
        });
    });

    // Точечные объекты
    DotObjectTypes.forEach(function (type) {
      addOverlay(ObjectTypes.getName(ObjectTypes.DotObject) + '-' + type.Id)
        .on('show', function (overlay) {
          loadDotObjects(type.Id, overlay);
        });
    });

    // Транспортные средства
    VehicleTypes.forEach(function (type) {
      vehiclesLayer.push(addOverlay(ObjectTypes.getName(ObjectTypes.Vehicle) + '-' + type.Id)
        .on('show', function (overlay) {
          overlay.alreadyActive = false; // Активность пункта меню зависит от активности слоя
          loadVehicles(type.Id, overlay).done(function () {
            overlay.canUpdate = true;
          });
        }));
    });

    // Чрезвычайные ситуации
    EmergencyTypes.forEach(function (type) {
      addOverlay(ObjectTypes.getName(ObjectTypes.Emergency) + '-' + type.Id)
        .on('show', function (overlay) {
          loadEmergencies(type.Id, overlay);
        });
    });

    // Видеонаблюдение
    addOverlay(ObjectTypes.getName(ObjectTypes.VideoCamera))
      .on('show', function (overlay) {
        loadVideoCameras(overlay);
      });

    // Метеостанции
    addOverlay(ObjectTypes.getName(ObjectTypes.WStation))
      .on('show', function (overlay) {
        loadWStations(overlay);
      });

    // Работы
    WorkTypes.forEach(function (type) {
      addOverlay(ObjectTypes.getName(ObjectTypes.Work) + '-' + type.Id)
        .on('show', function (overlay) {
          loadWorks(type.Id, overlay);
        });
    });

    // Метеопрогноз
    var addWeatherOverlay = function (name, zindex) {
      var newOverlay = new Overlay(name, leafletMap, L.tileLayer('', { zIndex: zindex }), 'Weather')
        .on('show', function() {
          WeatherForecast.showLayer(name);
        })
        .on('hide', function (overlay) {
          $('[data-id=' + overlay.name + ']').closest('.active').removeClass('active');
        });
      mapOverlays.push(newOverlay);
      return newOverlay;
    };

    var tempLayer = addWeatherOverlay('Weather-Temp', 1);
    var rainLayer = addWeatherOverlay('Weather-Rain', 2);
    var windLayer = addWeatherOverlay('Weather-Wind', 3);

    WeatherForecast.init(tempLayer, rainLayer, windLayer, weatherOptions);

    return {
      showObjects: showObjects,
      toggleLayer: toggleLayer
    };
  };


  /**
   * Переключает видимость слоев карты
   * @param {string} name Название слоя
   * @param {boolean} active Если true, слой показывается, иначе скрывается.
   */
  function toggleLayer(name, active) {
    var overlay = mapOverlays.get(name);
    if (overlay) {
      if (overlay.group) {
        if (active) {
          mapOverlays.getGroup(overlay.group).forEach(function (x) { x.hide(); });
        }
        WeatherForecast.clearLayer();
      }
      overlay.toggle(active);
      //searchOverlay.hide();
    }
  };

  /**
   * Скроет все слои на карте
   */
  function hideAllOverlays() {
    mapOverlays.forEach(function (overlay) {
      overlay.hide();
    });
    //скрываем меню слоев и убираем активные элементы
    $('#sidebar-js').removeClass('menu-show');
    WeatherForecast.clearLayer();
  };

    function removeDuplicatesFromSearch(layers) {
        searchOverlay.layer.getLayers().forEach(function(layer) {
            var duplicate = layers.filter(function(f) {
                return f.options.id === layer.options.id
                    && f.options.typeId === layer.options.typeId;
            });
            if (duplicate.length)
                searchOverlay.layer.removeLayer(layer);
        });
    }


  /**
   * Инициализирует плагин для поиска объектов на карте и их отрисовки
   */
  function initSearch() {
    //контейнер плагина
    var $mapSearch = $('[js=map-search]');
    //кнопка поиска
    var $btn = $mapSearch.find('button');
    //поле ввода с автодополнением
    var $autocomplete = $mapSearch.find('input');

    //инициализируем кнопку
    $btn.on('click', function () {
      var query = $autocomplete.val();
      if (typeof query === 'string' && query.length > 0) {
        $.post(Url.action('map/search'), { query: query }).done(
          /**
           * Обработает полученные от сервера данные
           * @param {Smik.WebSite.Models.CommonSearchModel} entities Коллекции найденных сущностей
           */
          function (entities) {
            //searchOverlay.clearLayers();
            var serviceZoneLayers = entities.ServiceZone
                  .map(function (x) { return createServiceZoneLayer(x); });
            var layers = [].concat(
              serviceZoneLayers,
              entities.Roads
                .map(function(x) { return createRoadLayer(x); }),
              entities.SectionService
                .map(function(x) { return createSSegmentLayer(x); }),
              entities.LongObject
                .map(function(x) { return createLongObjectLayer(x); }),
              entities.DotObject
                .map(function(x) { return createDotObjectLayer(x); }),
              entities.Vehicle
                .map(function(x) { return createVehicleLayer(x); }),
              entities.Emergency
                .map(function(x) { return createEmergencyLayer(x); }),
              entities.WStation
                .map(function(x) { return createWStationLayer(x); }),
              entities.Camera
                .map(function(x) { return createVideoCameraLayer(x); }),
              entities.Locality
                .map(function (x) { return createLocalityLayer(x); })
              );

              // Удаление undefined слоев
              layers = layers.filter(function(l) { return l; });
              removeDuplicatesFromSearch(layers);

              searchOverlay.addLayers(layers).fit();
              //hideAllOverlays();
              searchOverlay.show();
            if (serviceZoneLayers) {
                $.each(serviceZoneLayers,
                    function (idx, layer) {
                        if (layer) {
                            layer.bringToBack(); // Всегда в самом низу
                        }
                    });
              };
            $autocomplete.val(query);
          });
      }
    });

    //инициализируем поле с автодополнением
    $autocomplete.typeahead({
      source: function (query, process) {
        $.post(Url.action('map/autocomplete'), { query: query }).done(process);
      },
      afterSelect: function () {
        $btn.trigger('click');
      },
      minLength: 2
    });

    //когда слой поиска скрывается, очищаем поле поиска
    searchOverlay.on('hide', function() {
      $autocomplete.val('');
    });
  };


  /**
   * Создаст слой для дороги по модели
   * @param {RoadMap} road Модель дороги
   * @returns {Layer} Leaflet слой
   */
  function createRoadLayer(road) {

    var coordinates = MapHelper.convertToLatLng(road.Coordinates);
      var layer = L.polyline(coordinates, {
          color: road.Type.Id === 1 ? "#A52A2A" : road.Type.Id === 2 ? "#393939" : "#808080",
          weight: 5,
          smoothFactor: 1,
          opacity: .8,
          id: road.Id,
          typeId: ObjectTypes.Road
      });
      layer.startKm = road.StartKm;

    var text = '{Name}<br/>Код: {Code}'.format(road);
    layer.bindPopup(text, {
      id: road.Id,
      typeId: ObjectTypes.Road
    });

    layer.on('click', function (e) {
        var distance = MapHelper.findPosition(e.latlng, coordinates, MapHelper.getZoom(leafletMap).coefficient);
        var out = Math.round(distance.distance) / 1000 + this.startKm;
        if (distance.isInEdge) {
            popup
              .setLatLng(e.latlng)
              .setContent('Широта: ' + e.latlng.lat + '<br>' + 'Долгота: ' + e.latlng.lng + '<br>' + out + ' километр')
              .openOn(leafletMap);
        }
    });
    return layer;
  };

  /**
   * Создаст слой для участка обслуживания
   * @param {SSegmentMap} ssegment Модель участка обслуживания
   * @returns {Layer} Leaflet слой
   */
  function createSSegmentLayer(ssegment) {

    if (ssegment.RoadCoordinates.length === 0) return undefined;

    var coordinates = MapHelper.getCoordinatesByStartEnd(
      MapHelper.convertToLatLng(ssegment.RoadCoordinates),
      (ssegment.StartKm - ssegment.RoadStartKm) * 1e3,
      (ssegment.StopKm - ssegment.RoadStartKm) * 1e3);

    var layer = L.polyline(coordinates, {
      color: 'orange',
      weight: 4,
      smoothFactor: 1,
      opacity: .8,
      id: ssegment.Id,
      typeId: ObjectTypes.SSegment
    });

    var text = ssegment.Name;
    layer.bindPopup(text, {
      id: ssegment.Id,
      typeId: ObjectTypes.SSegment
    });
    return layer;
  };

  /**
   * Создаст слой для протяженного объекта
   * @param {LongObjectMap} longObject Модель протяженного объекта
   * @returns {Layer} Leaflet слой
   */
  function createLongObjectLayer(longObject) {
    var layerGroup = L.featureGroup();

    longObject.LongObjectRoads.forEach(function (lrRoad) {
      if (lrRoad.Coordinates.length > 0) {

        var coordinates = MapHelper.getCoordinatesByStartEnd(
          MapHelper.convertToLatLng(lrRoad.Coordinates),
          (lrRoad.StartKm -lrRoad.Road.StartKm) * 1e3,
            (lrRoad.StopKm - lrRoad.Road.StartKm) * 1e3);

        if (coordinates.length === 0)
          return;

        var text = 'Автодорога: {Name}<br />Код: {Code}'.format(lrRoad.Road)
          + '<br />Находится в: {Name}'.format(longObject);

        var line = L.polyline(coordinates,
        {
          color: '#008000',
          weight: 4,
          smoothFactor: 1,
          opacity: .8,
          id: longObject.Id,
          typeId: ObjectTypes.LongObject
        });
        line.bindPopup(text, {
          id: longObject.Id,
          typeId: ObjectTypes.LongObject
        });
        layerGroup.addLayer(line);
      }
    });

    return layerGroup;
  };

  /**
   * Создаст слой для точечного объекта
   * @param {DotObjectMap} dotObject Модель точечного объекта
   * @returns {Marker} Leaflet маркер
   */
    function createDotObjectLayer(dotObject) {

        var coordinate;
        var popupText;
        if (dotObject.Coordinate && dotObject.Type.FreeLocation) {
            coordinate = MapHelper.convertToLatLng(dotObject.Coordinate);
            popupText = dotObject.Name;
        } else if (dotObject.RoadCoordinates && dotObject.RoadCoordinates.length) {
            coordinate = MapHelper.findPositionByDistance((dotObject.Location - dotObject.RoadStartKm) * 1e3, MapHelper.convertToLatLng(dotObject.RoadCoordinates)).point;
            popupText = dotObject.Name + "<br />На " + dotObject.Location + "км";
        } else
            return undefined;
        if (!dotObject.Type.Icon || 0 === dotObject.Type.Icon.length)
            dotObject.Type.Icon = 'dotobject';
        var markerIcon = L.icon({
            popupAnchor: [12, 92],
            iconSize: [],
            iconAnchor: [12, 46],
            iconUrl: Url.icon('empty-min.png'),
            className: dotObject.Type.Icon.toLowerCase()
        });
        var marker = L.marker(coordinate,
            {
                icon: markerIcon,
                riseOnHover: true,
                title: '"' + dotObject.Type.Name + '" ' + dotObject.Name,
                alt: '"' + dotObject.Type.Name + '" ' + dotObject.Name,
                id: dotObject.Id,
                typeId: ObjectTypes.DotObject
            });
        
        marker.bindPopup(popupText,
            {
                id: dotObject.Id,
                typeId: ObjectTypes.DotObject
            });

    return marker;
  };

  /**
   * Создаст слой для населенного пункта
   * @param {LocalityMap} locality Модель населенного пункта
   * @returns {Layer}
   */
  function createLocalityLayer(locality) {
    var localityLayerGroup = L.featureGroup();
    locality.LocalityRoads.forEach(function (lr) {
      if (lr.Coordinates.length > 0) {
        var coordinates = MapHelper.getCoordinatesByStartEnd(
          MapHelper.convertToLatLng(lr.Coordinates),
            (lr.StartKm - lr.Road.StartKm) * 1e3,
            (lr.StopKm - lr.Road.StartKm) * 1e3);

        if (coordinates.length === 0)
          return;

        var line = L.polyline(coordinates,
        {
          color: "#808080",
          weight: 15,
          smoothFactor: 1,
          opacity: .8,
          id: locality.Id,
          typeId: ObjectTypes.Locality
        });

        line.bindPopup(locality.Name, {
          id: locality.Id,
          typeId: ObjectTypes.Locality
        });

        localityLayerGroup.addLayer(line);
      }
    });

    return localityLayerGroup;
  };

  /**
   * Создаст слой для транспорта
   * @param {VehicleMap} vehicle Модель транспорта
   * @returns {Layer} Слой ТС
   */
  function createVehicleLayer(vehicle) {
    if (!vehicle.Coordinate) return undefined;

    var iconClass = VehicleTypeEnum[vehicle.Type.Id].toLowerCase();
    var markerIcon = L.icon({
      popupAnchor: [12, 92],
      iconSize: [],
      iconAnchor: [12, 46],
      iconUrl: Url.icon('empty-min.png'),
      className: iconClass + 'icon'
    });

    var titleFormat = '"{0}" {1}'.format(vehicle.Brand, vehicle.RegistrationNumber);
    var title = titleFormat;

    if (!isNaN(parseFloat(vehicle.Speed)) && isFinite(vehicle.Speed)) {
      title += ', {0} км/ч'.format(vehicle.Speed);
    }

    var marker = L.marker(MapHelper.convertToLatLng(vehicle.Coordinate), {
      icon: markerIcon,
      riseOnHover: true,
      title: title,
      alt: title,
      objectType: ObjectTypes.Vehicle,
      objectId: vehicle.Id,
      trackerId: vehicle.TrackerId,
      id: vehicle.Id,
      typeId: ObjectTypes.Vehicle
    });
    marker.titleFormat = titleFormat;
    marker.bindPopup('{0}<br/>{1}'.format(vehicle.Type.Name, vehicle.RegistrationNumber), {
      id: vehicle.Id,
      typeId: ObjectTypes.Vehicle
    });

    return marker;
  }

  /**
   * Создаст слой для чрезвычайной ситуации
   * @param {EmergencyMap} emergency Модель чрезвычайной ситуации
   * @returns {Layer} слой ЧС
   */
  function createEmergencyLayer(emergency) {
    if (emergency.RoadCoordinates.length === 0) return undefined;

    if (emergency.Status.Id === 4) {
      // Последствия ликвидировали
      // TODO: зачем тогда загружать из БД
      return undefined;
    }

    var coordinates = MapHelper.getCoordinatesByStartEnd(
      MapHelper.convertToLatLng(emergency.RoadCoordinates),
        (emergency.StartKm - emergency.RoadStartKm) * 1e3,
        (emergency.StopKm - emergency.RoadStartKm) * 1e3);
 
    var layer = L.polyline(coordinates, {
      color: '#FF0000',
      weight: 4,
      smoothFactor: 1,
      opacity: .8,
      className: 'emergency',
      id: 'Emergency' + emergency.Id,
      parentId: emergency.Id,
      typeId: 'EmergencyRoad'
    });

    var text = '"' + emergency.Type.Name + '" ' + emergency.Name + ' <br/> c ' + emergency.StartKm + 'км по ' + emergency.StopKm + 'км';

    var middlePosition = MapHelper.findPositionByDistance((emergency.StopKm - emergency.StartKm) * 500, coordinates);

      var markerIcon = L.icon({
          popupAnchor: [12, 92],
          iconSize: [],
          iconAnchor: [12, 41],
          iconUrl: Url.icon('empty-min.png'),
          className: 'emergency'
      });

      var marker = L.marker(middlePosition.point, {
          icon: markerIcon,
          riseOnHover: true,
          title: '"{0}" {1}'.format(emergency.Type.Name, emergency.Name),
          alt: '"{0}" {1}'.format(emergency.Type.Name, emergency.Name),
          id: 'Emergency' + emergency.Id,
          parentId: emergency.Id,
          typeId: ObjectTypes.Emergency
      });

      layer
          .on('mouseover', function(e) {
              hoverLayer(marker, true);
          })
          .on('mouseout', function(e) {
              hoverLayer(marker, false);
          });

      marker
          .on('mouseover', function (e) {
              hoverLayer(layer, true);
          })
          .on('mouseout', function (e) {
              hoverLayer(layer, false);
          });


      var group = L.featureGroup([layer, marker]);
      group.bindPopup(text, {
          id: emergency.Id,
          typeId: ObjectTypes.Emergency
      });

      return group;
  };

  /**
   * Создаст слой для метеостанции
   * @param {WeatherStationMapModel} wstation Модель метеостанции
   * @returns {Layer}
   */
  function createWStationLayer(wstation) {
      if (!wstation.RoadCoordinates || !wstation.RoadCoordinates.length) return undefined;

    var markerIcon = L.icon({
      popupAnchor: [12, 92],
      iconSize: [],
      iconAnchor: [12, 46],
      iconUrl: Url.icon('empty-min.png'),
      className: 'wstationicon'
    });
      var coordinate = MapHelper.findPositionByDistance((wstation.Location - wstation.RoadStartKm) * 1e3, MapHelper.convertToLatLng(wstation.RoadCoordinates));
      var marker = L.marker(coordinate.point, {
      icon: markerIcon,
      riseOnHover: true,
      id: wstation.Id,
      typeId: ObjectTypes.WStation,
      loadedTooltip: false,
      loadingTooltip: false
    });

    marker.bindPopup('{Name}<br />На {Location}км'.format(wstation), {
      id: wstation.Id,
      typeId: ObjectTypes.WStation
      });

      marker.bindTooltip('Загрузка...', { opacity: 1, offset: L.point(0, -30) });
      marker
          .on('mouseover', function (e) {
              if (!this.options.loadedTooltip && !this.options.loadingTooltip) {
                  var url = CardUrls['WStationTooltip'].format(this.options.id);
                  loadWStationTooltip(url, this);
              }
          });

    return marker;
  };

  /**
   * Создаст слой для камеры видеонаблюдения
   * @param {VideoCameraMap} videoCamera Модель камеры видеонаблюдения
   * @returns {Layer}
   */
  function createVideoCameraLayer(videoCamera) {
      if (!videoCamera.RoadCoordinates || !videoCamera.RoadCoordinates.length) return undefined;

    var markerIcon = L.icon({
      popupAnchor: [12, 92],
      iconSize: [],
      iconAnchor: [12, 46],
      iconUrl: Url.icon('empty-min.png'),
      className: 'videoicon'
    });
      var coordinate = MapHelper.findPositionByDistance((videoCamera.Location - videoCamera.RoadStartKm) * 1e3, MapHelper.convertToLatLng(videoCamera.RoadCoordinates));
      var marker = L.marker(coordinate.point,
          {
              icon: markerIcon,
              riseOnHover: true,
              title: videoCamera.Name,
              alt: videoCamera.Name,
              id: videoCamera.Id,
              typeId: ObjectTypes.VideoCamera
          });

    marker.bindPopup('{Name}<br/>На {Location}км'.format(videoCamera), {
      id: videoCamera.Id,
      typeId: ObjectTypes.VideoCamera
    });

    return marker;
  };

  /**
   * Создаст слой для работы
   * @param {WorkMap} work Модель работы
   */
  function createWorkLayer(work) {
    var coordinates = MapHelper.getCoordinatesByStartEnd(
      MapHelper.convertToLatLng(work.RoadCoordinates),
      (work.StartKm - work.RoadStartKm) * 1e3,
      (work.StopKm - work.RoadStartKm) * 1e3);

    if (coordinates.length === 0)
      return;

    var text = 'Работа: ' + work.Name;

    var line = L.polyline(coordinates, {
      color: 'blue', // ToDo Изменить цвет
      weight: 4,
      smoothFactor: 1,
      opacity: .8
    })
      .bindPopup(text, {
        id: work.Id,
        typeId: ObjectTypes.Work
      });
  }

  /**
 * Создаст слой для зон обслуживания
 * @param {ServiceZone} serviceZone Модель зоны обслуживания
 * @returns {Layer} Слой зон обслуживания
 */
  function createServiceZoneLayer(serviceZone) {
    if (serviceZone.Coordinates.length <=0 ) return undefined;

    var polygonPoints = MapHelper.convertToLatLng(serviceZone.Coordinates);

    var polygon = new L.Polygon(polygonPoints, {
      color: '#' + serviceZone.Color.Name,
      weight: 2,
      smoothFactor: 1,
      opacity: .9,
      fillOpacity: .8,
      id: serviceZone.Id,
      typeId: ObjectTypes.ServiceZone
    });

    // ServiceZone with card option
    polygon.bindPopup('<h2><p>' + serviceZone.Name + '</p></h2>', {
      id: serviceZone.Id,
      typeId: ObjectTypes.ServiceZone
    })
      .on('click', function (e) {
        L.popup()
          .setLatLng(e.latlng)
          .setContent('Широта: ' + e.latlng.lat.toFixed(5) + ' <br /> Долгота: ' + e.latlng.lng.toFixed(5))
          .openOn(leafletMap);
      });

    return polygon;
  };

  /**
   * Вернет коллекцию автодорог
   * @param {Object} data Данные для запроса
   * @param {number} data.roadType Тип дороги
   * @param {number[]} data.roadIds Идентификаторы дорог
   * @returns {Promise}
   */
  function getRoads(data) {
    return $.get(Url.api('api/roads/map'), data);
  }

  function getSSegments(data) {
    return $.get(Url.api('api/ssegments/map'), data);
  }

  function getLongObjects(data) {
    return $.get(Url.api('api/longObjects/map'), data);
  }

  function getDotObjects(data) {
    return $.get(Url.api('api/dotObjects/map'), data);
  }

  function getLocalities(data) {
    return $.get(Url.api('api/localities/map'), data);
  }

  function getVehicles(data) {
    return $.get(Url.api('api/vehicles/map'), data);
  }

  function getEmergencies(data) {
    return $.get(Url.api('api/emergencies/map'), data);
  }

  function getWStations(data) {
    return $.get(Url.api('api/wstations/map'), data);
  }

  function getVideoCameras(data) {
    return $.get(Url.api('api/videocameras/map'), data);
  }

  function getWorks(data) {
    return $.get(Url.api('api/works/map'), data);
  }

  function getServiceZones(data) {
    return $.get(Url.api('api/serviceZones/map'), data);
  }


  function showObjects(objectType, ids) {

    var findOverlay = function (name) {
      return mapOverlays.filter(function (x) { return x.name === name; })[0];
    };

    var addToMap = function (overlayName, layer) {
      if (layer) {
        var overlay = findOverlay(overlayName);
        overlay.addLayer(layer);
        overlay.layer.isShown = true; // Устанавливаем для сортировки слоя
        layer.addTo(leafletMap);
        orderOverlays();
      }
      return layer;
    };

    switch (objectType) {

      case ObjectTypes.ServiceZone:
        return getServiceZones({ serviceZoneIds: ids }).then(function (serviceZones) {
          serviceZones.forEach(function (serviceZone) {
            addToMap(ObjectTypes.getName(objectType), createServiceZoneLayer(serviceZone));
          });
        });

      case ObjectTypes.Road:
        return getRoads({ roadIds: ids }).then(function(roads) {
          roads.forEach(function(road) {
            addToMap(ObjectTypes.getName(objectType) + '-' + road.Type.Id, createRoadLayer(road));
          });
        });

      case ObjectTypes.SSegment:
        return getSSegments({ ssegmentIds: ids }).then(function(ssegments) {
          ssegments.forEach(function(ssegment) {
            addToMap(ObjectTypes.getName(objectType) + '-' + (ssegment.Standart ? "True" : "False"), createSSegmentLayer(ssegment));
          });
        });

      case ObjectTypes.LongObject:
        return getLongObjects({ longObjectIds: ids }).then(function (longObjects) {
          longObjects.forEach(function (longObject) {
            addToMap(ObjectTypes.getName(objectType) + '-' + longObject.Type.Id, createLongObjectLayer(longObject));
          });
        });

      case ObjectTypes.DotObject:
        return getDotObjects({ dotObjectIds: ids }).then(function (dotObjects) {
          dotObjects.forEach(function (dotObject) {
            addToMap(ObjectTypes.getName(objectType) + '-' + dotObject.Type.Id, createDotObjectLayer(dotObject));
          });
        });

      case ObjectTypes.Locality:
        return getLocalities({ localityIds: ids }).then(function (localities) {
          localities.forEach(function (locality) {
            addToMap(ObjectTypes.getName(objectType), createLocalityLayer(locality));
          });
        });

      case ObjectTypes.Vehicle:
        return getVehicles({ vehicleIds: ids, isCommunicationTimed: false, hasMinSpeed: false }).then(function (vehicles) {
          vehicles.forEach(function (vehicle) {
            var layer = addToMap(ObjectTypes.getName(objectType) + '-' + vehicle.Type.Id, createVehicleLayer(vehicle));
          });
        });

      case ObjectTypes.Emergency:
        return getEmergencies({ emergencyIds: ids }).then(function (emergencies) {
          emergencies.forEach(function (emergency) {
            addToMap(ObjectTypes.getName(objectType) + '-' + emergency.Type.Id, createEmergencyLayer(emergency));
          });
        });

      case ObjectTypes.WStation:
        return getWStations({ wstationIds: ids }).then(function (wstations) {
          wstations.forEach(function (wstation) {
            addToMap(ObjectTypes.getName(objectType), createWStationLayer(wstation));
          });
        });

      case ObjectTypes.VideoCamera:
        return getVideoCameras({ videoCameraIds: ids }).then(function (videoCameras) {
          videoCameras.forEach(function (videoCamera) {
            addToMap(ObjectTypes.getName(objectType), createVideoCameraLayer(videoCamera));
          });
        });
    }
  };

  // Загружает Зоны обслуживания с сервера и добавляет слои ЗО на карту
  function loadServiceZones(overlay) {
    var getData = function (page, count) {
      return getServiceZones({ page: page, count: count });
    };
    var processData = function (serviceZones) {
      serviceZones.forEach(function (serviceZone) {
        var layer = createServiceZoneLayer(serviceZone);
        if (layer) {
          overlay.addLayer(layer);
          layer.bringToBack(); // Всегда в самом низу
        }
      });
    };
    batchLoad(getData, processData);
  };

  /**
   * Загружает автодороги с сервера и добавляет слои автодорог на карту
   * @param {number} Тип дороги
   * @param {Overlay} Слой карты, на который будут добавляться слои автодорог
   */
  function loadRoads(type, overlay) {
    var getData = function (page, count) {
      return getRoads({ roadType: type, page: page, count: count });
    };
    var processData = function (roads) {
      roads.forEach(function (road) {
        var layer = createRoadLayer(road);
        if (layer) overlay.addLayer(layer);
      });
    };
    batchLoad(getData, processData);
  };

  /**
   * 
   * @param {} overlay 
   * @returns {} 
   */
  function loadLocalities(overlay) {
    var getData = function (page, count) {
      return getLocalities({ page: page, count: count });
    };
    var processData = function (localities) {
      localities.forEach(function (locality) {
        var layer = createLocalityLayer(locality);
        if (layer) overlay.addLayer(layer);
      });
    };
    batchLoad(getData, processData);
  };

  /**
   * 
   * @param {} state 
   * @param {} overlay 
   * @returns {} 
   */
  function loadSSegments(type, overlay) {
    var getData = function (page, count) {
      return getSSegments({ type: type, page: page, count: count });
    };
    var processData = function (ssegments) {
      ssegments.forEach(function (ssegment) {
        var layer = createSSegmentLayer(ssegment);
        if (layer) overlay.addLayer(layer);
      });
    };
    batchLoad(getData, processData);
  };

  /**
   * 
   * @param {} type 
   * @param {} overlay 
   * @returns {} 
   */
  function loadLongObjects(type, overlay) {
    var getData = function (page, count) {
      return getLongObjects({ longObjectType: type, page: page, count: count });
    };
    var processData = function (longObjects) {
      longObjects.forEach(function (longObject) {
        var layer = createLongObjectLayer(longObject);
        if (layer) overlay.addLayer(layer);
      });
    };
    batchLoad(getData, processData);
  };

  /**
   * 
   * @param {} type 
   * @param {} overlay 
   * @returns {} 
   */
  function loadDotObjects(type, overlay) {
    var getData = function (page, count) {
      return getDotObjects({ dotObjectType: type, page: page, count: count });
    };
    var processData = function (dotObjects) {
      dotObjects.forEach(function (dotObject) {
        var layer = createDotObjectLayer(dotObject);
        if (layer) overlay.addLayer(layer);
      });
    };
    batchLoad(getData, processData);
  };

  /**
   * 
   * @param {} type 
   * @param {} overlay 
   * @returns {} 
   */
  function loadVehicles(type, overlay) {
    var processData = function (vehicles) {
      vehicles.forEach(function (vehicle) {
        var layer = createVehicleLayer(vehicle);
        if (layer) overlay.addLayer(layer);
      });
    };
    return getVehicles({
        vehicleType: type,
        isCommunicationTimed: $('#IsCommunicationTimed').prop('checked'),
        hasMinSpeed: $('#HasMinSpeed').prop('checked'),
        page: 0,
        count: 0
        })
      .then(function (response) {
        processData(response.Data);
        orderOverlays();
      });
  };

  /**
   * 
   * @param {} type 
   * @param {} overlay 
   * @returns {} 
   */
  function loadEmergencies(type, overlay) {
    var getData = function (page, count) {
      return getEmergencies({ emergencyType: type, page: page, count: count });
    };
    var processData = function (emergencies) {
      emergencies.forEach(function (emergency) {
        var layer = createEmergencyLayer(emergency);
        if (layer) overlay.addLayer(layer);
      });
    };
    batchLoad(getData, processData);
  };

  /**
   * 
   * @param {} type 
   * @param {} overlay 
   * @returns {} 
   */
  function loadVideoCameras(overlay) {
    var getData = function (page, count) {
      return getVideoCameras({ page: page, count: count });
    };
    var processData = function (videoCameras) {
      videoCameras.forEach(function (videoCamera) {
        var layer = createVideoCameraLayer(videoCamera);
        if (layer) overlay.addLayer(layer);
      });
    };
    batchLoad(getData, processData);
  };

  /**
   * 
   * @param {} type 
   * @param {} overlay 
   * @returns {} 
   */
  function loadWStations(overlay) {
    var getData = function (page, count) {
      return getWStations({ page: page, count: count });
    };
    var processData = function (wstations) {
      wstations.forEach(function (wstation) {
        var layer = createWStationLayer(wstation);
        if (layer) overlay.addLayer(layer);
      });
    };
    batchLoad(getData, processData);
  };

  /**
   * 
   * @param {} type 
   * @param {} overlay 
   * @returns {} 
   */
  function loadWorks(type, overlay) {
    var getData = function (page, count) {
      return getWorks({ workType: type, page: page, count: count });
    };
    var processData = function (works) {
      works.forEach(function (work) {
        var layer = createWorkLayer(work);
        if (layer) overlay.addLayer(layer);
      });
    };
    batchLoad(getData, processData);
  };

  /**
   * 
   * @param {} getData 
   * @param {} processData 
   * @returns {} 
   */
  function batchLoad(getData, processData) {
    return getData(0, config.count).then(function (response) {
      processData(response.Data);
      for (var i = 1; i < response.PageCount; i++) {
        getData(i, config.count).then(function (response2) {
          processData(response2.Data);
          orderOverlays();
        });
      }
    });
  };

  function orderOverlays() {
    mapOverlays.forEach(function (overlay) {
      if (overlay.isShown || overlay.layer.isShown)
        overlay.layer.bringToFront();
      _sortingServiceZones(overlay); // Сортирует слои ЗО
    });
  };

  // Отправляет ЗО всегда в самый низ
  function _sortingServiceZones(overlay) {
    if (overlay && overlay.name === ObjectTypes.getName(ObjectTypes.ServiceZone)) {
      if (overlay.layer && overlay.layer._layers) {
        $.each(overlay.layer._layers, function (idx, layer) {
          if (layer) {
            layer.bringToBack(); // Всегда в самом низу
          }
        });
      }
    }
  }

  return {
    pageInit: pageInit,
    mapInit: mapInit
  };
}());
